import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { createRef } from "react";
import { getToken } from "../../../components/src/AuthService";

// Customizable Area Start
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  classes?: any;
  history?: any;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  token: string;
  title: string;
  description: string;
  account_id: number;
  anonymous: boolean;
  ReviewsList: [];
  activeCreatedAt: string;
  isVisible: boolean;
  accountReview: any;
  currentStep: number;
  rating: number;
  phoneNumber: string;
  countryCode: string;
  otpCode: string[];
  isSubmitting: boolean;
  sortAnchorEl: HTMLElement | null;
  sortBy: string;
  isResending: boolean;
  userName: string;
  reviewDataShow: any;
  reviewData:any;
  userToken:string;
  openReviewComments:any;
  reviewComments:any;
  reviewCommentText:string;
  reviewCommentDrafts: Record<string, string>;
  commentAuthOpen: boolean;
  commentAuthStep: number;
  pendingCommentReviewId: string | number | null;
  authFlowSource: "review" | "comment";
  phoneError: string;
  otpError: string;
  // Customizable Area End
}

interface SS {
  id: any;
}

export default class ReviewsController extends BlockComponent<Props, S, SS> {
  reviewsApiCallId: any;
  userSignInApiCallId:any;
  otpVerifyApiCallId:any;
  submitReviewApiCallId:any;
  reviewLikeApiCallId: any;
  pendingReviewLikeId: string | number | null;
  deleteReviewApiCallId: any;
  addReviewApiCallId: any;
  updateReviewApiCallId: any;
  likeStateStorageKey = "everybrand_review_like_state";
  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.RestAPIResponceMessage)
    ];

    this.state = {
      title: "",
      description: "",
      account_id: 1,
      anonymous: false,
      token: "",
      ReviewsList: [] as any,
      accountReview: null,
      activeCreatedAt: "",
      isVisible: false,
      currentStep: 0,
      rating: 0,
      phoneNumber: "",
      countryCode: "+1",
      otpCode: Array(6).fill(""),
      isSubmitting: false,
      sortAnchorEl: null as HTMLElement | null,
      sortBy: 'Newest',
      userName: "",
      isResending: false,
      reviewDataShow:[],
      reviewData:[],
      userToken:"",
      openReviewComments:"",
      reviewComments:{},
      reviewCommentText:"",
      reviewCommentDrafts: {},
      commentAuthOpen: false,
      commentAuthStep: 0,
      pendingCommentReviewId: null,
      authFlowSource: "review",
      phoneError: "",
      otpError: "",
    };
    this.pendingReviewLikeId = null;

    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }
  inputRefs = Array(6)
      .fill(null)
      .map(() => createRef<HTMLInputElement>());
  async componentDidMount() {
    super.componentDidMount();
    this.getToken1();
    if (this.isPlatformWeb() === false) {
      this.props.navigation.addListener("willFocus", () => {
        this.getToken1();
      });
    }
    // Customizable Area Start
    // Customizable Area End
  }

  getToken1 = () => {
    const msg: Message = new Message(
      getName(MessageEnum.SessionRequestMessage)
    );
    this.send(msg);
  };

  getStoredLikeState = (): Record<string, boolean> => {
    try {
      const raw = window.localStorage.getItem(this.likeStateStorageKey);
      const parsed = raw ? JSON.parse(raw) : {};
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (_e) {
      return {};
    }
  };

  setStoredLikeState = (reviewId: string | number, isLiked: boolean) => {
    try {
      const state = this.getStoredLikeState();
      state[String(reviewId)] = isLiked;
      window.localStorage.setItem(this.likeStateStorageKey, JSON.stringify(state));
    } catch (_e) {
      // Ignore localStorage errors.
    }
  };

  async receive(from: string, message: Message) {
    // Customizable Area Start
    runEngine.debugLog("Message Recived", message);
    if (this.props.navigation?.history?.location?.state?.rating){
      runEngine.debugLog("Message Recived rating", this.props.navigation?.history?.location?.state);
      this.setState({ rating: this.props.navigation?.history?.location?.state?.rating });
    }

    if (getName(MessageEnum.SessionResponseMessage) === message.id) {
      console.log("enter user on thos function");
      
      let token = getToken();
      this.setState({ token });
      
      this.getReviewsList();
    } else if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      var responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      runEngine.debugLog("API Message Recived", message);

      if (responseJson && responseJson.data) {
        if (apiRequestCallId === this.reviewsApiCallId) {
          this.setState({ accountReview: responseJson.data });
          console.log("responseJson.data",responseJson.data);
          
          const storedLikeState = this.getStoredLikeState();
          const formattedReviews = responseJson.data.map((item: any) => {
            const resolvedLikeCount = Number(
              item.attributes.like_count ?? item.attributes.likes_count ?? item.attributes.likes ?? 0
            );
            const apiIsLiked = item.attributes.is_liked ?? item.attributes.liked_by_current_user;
            const resolvedIsLiked =
              typeof apiIsLiked === "boolean"
                ? apiIsLiked
                : Boolean(storedLikeState[String(item.id)] ?? false);
            return {
            id: item.id,
            userName: item.attributes.reviewer_name || "User Not Found",
            userAvatar: item.attributes.reviewer_image || null,
            rating: item.attributes.rating,
            comment: item.attributes.description,
            date: item.attributes.created_at,
            like_count: resolvedLikeCount,
            isLiked: resolvedIsLiked,
          };
          });
          
          this.setState(
            { reviewDataShow: formattedReviews },            
          );
          
        }
        if (apiRequestCallId === this.userSignInApiCallId) {
          const token = responseJson?.meta?.token;
        
          if (token) {
            this.setState(
              { userToken: token, otpError: "", phoneError: "" },
              () => {
              if (this.state.authFlowSource === "comment") {
                this.setState({ commentAuthStep: 2 });
              } else {
                this.nextStep(); // move to OTP step (3)
              }
              }
            );
          }
        }
        
        if (apiRequestCallId === this.otpVerifyApiCallId) {

          const token = responseJson?.meta?.token;
        
          if (token) {
            if (this.state.authFlowSource === "comment") {
              const reviewId = this.state.pendingCommentReviewId;
              this.setState(
                {
                  userToken: token,
                  commentAuthOpen: false,
                  commentAuthStep: 0,
                  pendingCommentReviewId: null,
                  otpCode: Array(6).fill(""),
                  otpError: "",
                },
                () => {
                  if (reviewId !== null && reviewId !== undefined) {
                    this.postReviewComment(reviewId);
                  }
                }
              );
            } else {
              this.setState({
                userToken: token,
                currentStep: 4,   // 🔥 FORCE to Review Preview step
                otpError: "",
              });
            }
          } else {
            this.setState({
              otpError: "Invalid OTP",
            });
          }
        }
        
        
        
        if (apiRequestCallId === this.submitReviewApiCallId) {
          this.setState({ isSubmitting: false });
        
          console.log("Review Response:", responseJson);
        
          if (responseJson?.data) {
            // this.nextStep(); // move to success step (4)
            // Force Reviews page to remount (and re-fetch list) by changing query string.
            this.props.navigation?.history?.push(
              `Reviews?isReviewSubmit=true&_=${Date.now()}`
            );
          } else {
            alert("Review submission failed");
          }
        }
        
        
        
        if (apiRequestCallId === this.addReviewApiCallId || apiRequestCallId === this.updateReviewApiCallId) {
          console.log("add review" + responseJson.data.id);
          if (responseJson.data.id === null) {
            this.updateQueryApi();
          } else {
            this.props.navigation.goBack();
          }
        }
        if (apiRequestCallId === this.reviewLikeApiCallId) {
          const response = message.getData(
            getName(MessageEnum.RestAPIResponceSuccessMessage)
          );
        
          if (response && this.pendingReviewLikeId) {
            const updated = this.state.reviewDataShow.map((item: any) => {
              if (item.id === this.pendingReviewLikeId) {
                const nextLiked =
                  typeof response.is_liked === "boolean"
                    ? response.is_liked
                    : item.isLiked;
                const nextLikeCount = Number(
                  response.like_count ??
                    response.likes_count ??
                    response.likes ??
                    item.like_count ??
                    0
                );
                return {
                  ...item,
                  isLiked: nextLiked,
                  like_count: nextLikeCount,
                };
              }
              return item;
            });
        
            this.setState({ reviewDataShow: updated });
            const updatedReview = updated.find((r: any) => r.id === this.pendingReviewLikeId);
            if (updatedReview) {
              this.setStoredLikeState(this.pendingReviewLikeId, Boolean(updatedReview.isLiked));
            }
            this.pendingReviewLikeId = null;
          }
        }
      } else if (responseJson && responseJson.errors) {
        if (apiRequestCallId === this.reviewLikeApiCallId && this.pendingReviewLikeId !== null) {
          // Revert optimistic like update if API fails
          this.setState((prevState) => ({
            reviewDataShow: prevState.reviewDataShow.map((item: any) => {
              if (item.id !== this.pendingReviewLikeId) return item;
              return {
                ...item,
                isLiked: !item.isLiked,
                like_count: item.isLiked
                  ? Math.max((item.like_count || 0) - 1, 0)
                  : (item.like_count || 0) + 1,
              };
            }),
          }));
          this.pendingReviewLikeId = null;
        }
        if (responseJson.errors) {
          if (apiRequestCallId === this.otpVerifyApiCallId) {
            const firstError = Array.isArray(responseJson.errors)
              ? responseJson.errors[0]
              : responseJson.errors;
            const otpErrorMessage =
              (firstError && (firstError.otp || firstError.error)) ||
              "Invalid OTP for Signup";
            this.setState({
              otpError: otpErrorMessage,
            });
          } else if (apiRequestCallId === this.userSignInApiCallId) {
            const firstError = Array.isArray(responseJson.errors)
              ? responseJson.errors[0]
              : responseJson.errors;

            const phoneErrorMessage =
              (firstError &&
                (firstError.full_phone_number ||
                  firstError.phone_number ||
                  firstError.fullPhoneNumber)) ||
              (typeof firstError === "string" ? firstError : undefined) ||
              "Invalid or Unrecognized Phone Number";

            this.setState({ phoneError: phoneErrorMessage, otpError: "" });
          } else if (apiRequestCallId === this.updateReviewApiCallId || apiRequestCallId === this.addReviewApiCallId) {
            responseJson.errors.forEach((error: any) => {
              if (error["token"]) {
                this.showAlert(configJSON.errorTitle, error["token"]);
                this.props.navigation.goBack();
              } else if (error["review"]) {
                this.showAlert(configJSON.errorTitle, error["review"].join("."));
                this.props.navigation.goBack();
              } else {
                this.showAlert(configJSON.errorTitle, error);
              }
            })
          }
        }
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  

 // Navigation
  handleRedirect = (path: string) => {
    const currentSearch = window.location.search;
    let newPath = path;

    const hasExistingQuery = path.includes('?');

    if (currentSearch) {
      const separator = hasExistingQuery ? '&' : '?';
      const searchParams = currentSearch.startsWith('?') ? currentSearch.substring(1) : currentSearch;
      newPath = `${path}${separator}${searchParams}`;
    }

    if (path === "AddReview") {
      this.props.navigation?.history?.push(newPath, { rating: this.state.rating });
    } else {
      this.props.navigation?.history?.push(newPath);
    }
  };

  getBusinessAccountId = (): number => {
    if (this.isPlatformWeb()) {
      const params = new URLSearchParams(window.location.search);
      const candidates = [
        params.get("businessId"),
        params.get("business_id"),
        params.get("account_id"),
      ];

      for (const rawValue of candidates) {
        if (!rawValue) continue;
        const cleanedValue = decodeURIComponent(String(rawValue)).trim();
        if (
          !cleanedValue ||
          cleanedValue === "undefined" ||
          cleanedValue === "null"
        ) {
          continue;
        }

        // Handles values like "89", "89&x=1", or "89#hash".
        const numericPrefix = cleanedValue.match(/^\d+/)?.[0];
        if (!numericPrefix) continue;
        const parsedId = Number(numericPrefix);
        console.log("parsedId", parsedId);
        if (Number.isFinite(parsedId) && parsedId > 0) {
          return parsedId;
        }
      }
    }
    return this.state.account_id;
  };

  handleClose = () => {
  console.log("Dispatching close event...");
  window.parent.postMessage({ 
    type: "EVERYBRAND_CLOSE_MODAL",
    source: "reviews-widget"
  }, "*");
  
  // Fallback: try direct parent communication
  if (window.parent !== window) {
    try {
      window.parent.postMessage({ 
        type: "EVERYBRAND_CLOSE_MODAL",
        source: "reviews-widget" 
      }, "*");
      console.log("Message posted to parent window");
    } catch (e) {
      console.error("Error posting message:", e);
    }
  }
};

  nextStep = () => {
    const { currentStep } = this.state;
    if (this.isStepValid(currentStep)) {
      this.setState({ currentStep: currentStep + 1 });
    }
  };

  handleContinue = () => {
    const { currentStep } = this.state;
  
    if (currentStep === 0) {
      this.nextStep();
    } 
    else if (currentStep === 1) {
      this.nextStep();
    } 
    else if (currentStep === 2) {
      this.handleUserSignIn(); // phone login
    } 
    else if (currentStep === 3) {
      this.handleOtpVerify(); // verify otp
    } 
    else if (currentStep === 4) {
      this.submitReview(); // 🔥 ONLY HERE review posts
    }
  };

  prevStep = () => {
    const { currentStep } = this.state;
    if (currentStep > 0) {
      this.setState({ currentStep: currentStep - 1 });
    }
  };

  // Validation
  isStepValid = (step: number): boolean => {
    const { rating, description, userName, phoneNumber, otpCode } = this.state;
    
    switch (step) {
      case 0: return rating > 0;
      case 1: return description.trim().length >= 5;
      case 2: return userName.trim().length >= 2;
      case 3: return /^\d{10}$/.test(phoneNumber);
      default: return true;
    }
  };

  // Form handlers
  setRating = (rating: number) => {
    this.setState({ rating });
  };

  handleOtpKeyDown = (e: any, index: number) => {
    if (e.key === "Backspace") {
      if (index < this.inputRefs.length) {
        const updatedOtp = [...this.state.otpCode];
        updatedOtp[index] = "";

        this.setState({ otpCode: updatedOtp });
        if (index !== 0) {
          this.inputRefs[index - 1].current?.focus();
        } else {
          this.inputRefs[index].current?.focus();
        }
      }
    } else if (e.key === "Delete") {
      if (index <= this.inputRefs.length - 1) {
        const updatedOtp = [...this.state.otpCode];

        updatedOtp[index] = "";

        this.setState({ otpCode: updatedOtp });
        if (index !== this.inputRefs.length - 1) {
          this.inputRefs[index + 1].current?.focus();
        } else {
          this.inputRefs[index].current?.focus();
        }
      }
    }
  };
  handleOtpChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, index: number) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 1) {
      const otp = this.state.otpCode;
      otp[index] = value;
      this.setState({ otpCode: otp, otpError: "" });
    }
    if (value && index < this.inputRefs.length - 1) {
      this.inputRefs[index + 1].current?.focus();
    } else if (!value && index > 0) {
      this.inputRefs[index - 1].current?.focus();
    }
  };

  resendOtp = () => {
    this.setState({ isResending: true });
    // Simulate API call
    setTimeout(() => {
      this.setState({ isResending: false });
    }, 2000);
  };

  // Review actions
  toggleLike = (id: any) => {
    const activeToken =
      this.state.userToken ||
      this.state.token ||
      window.localStorage.getItem("EUAuthToken") ||
      getToken();
  
    // ✅ Optimistic UI update
    const updated = this.state.reviewDataShow.map((item: any) => {
      if (item.id === id) {
        const newLiked = !item.isLiked;
  
        return {
          ...item,
          isLiked: newLiked,
          like_count: newLiked
            ? (item.like_count || 0) + 1
            : Math.max((item.like_count || 0) - 1, 0),
        };
      }
      return item;
    });
  
    this.setState({ reviewDataShow: updated });
    const optimisticReview = updated.find((r: any) => r.id === id);
    if (optimisticReview) {
      this.setStoredLikeState(id, Boolean(optimisticReview.isLiked));
    }
  
    // ✅ API call
    const header: Record<string, string> = {
      "Content-Type": "application/json",
    };
  
    if (activeToken) {
      header.token = activeToken;
    }
  
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
  
    this.reviewLikeApiCallId = requestMessage.messageId;
    this.pendingReviewLikeId = id;
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.reviewLikeApiEndPoint
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPostMethod
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify({ review_id: id })
    );
  
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  
  

  // submitReview = () => {
  //   if (!this.isStepValid(this.state.currentStep)) return;

  //   this.setState({ isSubmitting: true });

  //   // Simulate API call
  //   setTimeout(() => {
  //     const newReview = {
  //       id: Date.now(),
  //       userName: this.state.userName,
  //       userAvatar: "",
  //       rating: this.state.rating,
  //       comment: this.state.description,
  //       date: new Date().toISOString().split('T')[0],
  //       likes: 0,
  //       isLiked: false,
  //     };

  //     this.setState(prevState => ({
  //       ReviewsList: [newReview, ...prevState.ReviewsList] as any,
  //       isSubmitting: false,
  //       currentStep: 0
  //     }));

  //     // Reset form
  //     this.setState({
  //       rating: 0,
  //       description: "",
  //       userName: "",
  //       phoneNumber: "",
  //       otpCode: Array(6).fill(""),
  //     });
  //   }, 1500);
  //   this.handleRedirect("Reviews?isReviewSubmit=true");
  // };

  // Menu handlers
  handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ sortAnchorEl: event.currentTarget });
  };

  handleMenuClose = (type?: string) => {
    const { reviewDataShow } = this.state;
  
    if (type) {
      let sortedData = [...reviewDataShow];
  
      if (type === "newest") {
        sortedData.sort(
          (a: any, b: any) =>
            new Date(b.date).getTime() - new Date(a.date).getTime()
        );
      }
  
      if (type === "highest") {
        sortedData.sort(
          (a: any, b: any) => b.rating - a.rating
        );
      }
  
      this.setState({
        reviewDataShow: sortedData,
        sortBy: type,
        sortAnchorEl: null
      });
    } else {
      this.setState({ sortAnchorEl: null });
    }
  };
  
  handleReviewComment = (reviewId?:any) => {
    this.setState({
      openReviewComments:
        this.state.openReviewComments === reviewId ? null : reviewId
    });
  };

  getCommentDraft = (reviewId?: any) => {
    if (reviewId === null || reviewId === undefined) return "";
    return this.state.reviewCommentDrafts[String(reviewId)] || "";
  };

  setCommentDraft = (reviewId: any, value: string) => {
    this.setState((prevState) => ({
      reviewCommentDrafts: {
        ...prevState.reviewCommentDrafts,
        [String(reviewId)]: value,
      },
    }));
  };

  closeCommentAuth = () => {
    this.setState({
      commentAuthOpen: false,
      commentAuthStep: 0,
      pendingCommentReviewId: null,
      userName: "",
      phoneNumber: "",
      otpCode: Array(6).fill(""),
      authFlowSource: "review",
    });
  };

  startCommentAuthFlow = (reviewId: any) => {
    this.setState({
      commentAuthOpen: true,
      commentAuthStep: 0,
      pendingCommentReviewId: reviewId,
      userName: "",
      phoneNumber: "",
      otpCode: Array(6).fill(""),
      authFlowSource: "comment",
    });
  };

  handleCommentAuthContinue = () => {
    const { commentAuthStep } = this.state;
    if (commentAuthStep === 0) {
      if (!this.state.userName.trim()) {
        alert("Please enter your name");
        return;
      }
      this.setState({ commentAuthStep: 1 });
      return;
    }

    if (commentAuthStep === 1) {
      this.handleUserSignIn();
      return;
    }

    if (commentAuthStep === 2) {
      this.handleOtpVerify();
    }
  };

  postReviewComment = (reviewId: any) => {
    const text = this.getCommentDraft(reviewId).trim();
    if (!text) return;

    const existing = this.state.reviewComments[reviewId] || [];
    const newComment = {
      id: Date.now(),
      userName: this.state.userName?.trim() || "You",
      text,
    };

    this.setState((prevState) => ({
      reviewComments: {
        ...prevState.reviewComments,
        [reviewId]: [...existing, newComment],
      },
      reviewCommentDrafts: {
        ...prevState.reviewCommentDrafts,
        [String(reviewId)]: "",
      },
      reviewCommentText: "",
    }));
  };

  handleAddReviewComment = (reviewId?: any) => {
    if (reviewId === null || reviewId === undefined) return;
    const text = this.getCommentDraft(reviewId).trim();
    if (!text) return;

    const activeToken =
      this.state.userToken ||
      this.state.token ||
      window.localStorage.getItem("EUAuthToken") ||
      getToken();

    if (!activeToken) {
      this.startCommentAuthFlow(reviewId);
      return;
    }

    this.postReviewComment(reviewId);
  };

  isStringNullOrBlank(str: string) {
    return str === null || str.length === 0;
  }

  updateQueryApi = () => {
    console.log("update");
    let data = {
      data: {
        attributes: {
          title: this.state.title,
          description: this.state.description,
          account_id: this.state.account_id,
          anonymous: this.state.anonymous
        }
      }
    };

    const header = {
      "Content-Type": configJSON.ReviewsApiContentType,
      token: this.state.token
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.updateReviewApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getReviewsAPiEndPoint + "/" + this.state.account_id
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(data)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPutMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
  addQueryApi = () => {
    let data = {
      data: {
        attributes: {
          title: this.state.title,
          description: this.state.description,
          account_id: this.state.account_id,
          anonymous: this.state.anonymous
        }
      }
    };

    const header = {
      "Content-Type": configJSON.ReviewsApiContentType,
      token: this.state.token
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.addReviewApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getReviewsAPiEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(data)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPostMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    //@ts-ignore
    this.state.ReviewsList.push({ attributes: data.attributes });
  };

  getReviewsList = () => {
    const header = {
      "Content-Type": configJSON.ReviewsApiContentType,
      // token: token
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.reviewsApiCallId = requestMessage.messageId;

    console.log("reviews list", this.state.ReviewsList);
    const accountId = this.getBusinessAccountId();
    console.log("accountId", accountId);
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getBusinessReviewsAPiEndPoint + "?account_id=" + `${accountId}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleUserSignIn = () => {
    const { phoneNumber } = this.state;

    // Clear previous API errors when retrying
    if (this.state.phoneError) {
      this.setState({ phoneError: "" });
    }
  
    if (!phoneNumber || phoneNumber.replace(/\D/g, "").length < 10) {
      alert("Please enter a valid phone number");
      return false;
    }
  
    const header = {
      "Content-Type": "application/json"
    };
  
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
  
    this.userSignInApiCallId = requestMessage.messageId;
  
    // ✅ API Endpoint
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      "account_block/accounts/end_user_login"
    );
  
    // ✅ Headers
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
  
    // ✅ Method
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );
  
    // ✅ IMPORTANT — Add Body
    const requestBody = {
      data: {
        attributes: {
          full_phone_number: phoneNumber.startsWith("+")
            ? phoneNumber
            : `+${phoneNumber}`
        }
      }
    };
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(requestBody)
    );
  
    // ✅ Send API
    runEngine.sendMessage(requestMessage.id, requestMessage);
  
    return true;
  };
  
  handleOtpVerify = () => {
    const { otpCode, userToken, userName } = this.state;
  
    const otp = otpCode.join("");
  
    this.setState({ otpError: "" });

    if (otp.length !== 6) {
      this.setState({ otpError: "Please enter a valid 6-digit code" });
      return;
    }
  
    if (!userName) {
      this.setState({ otpError: "Name is required" });
      return;
    }
  
    const header = {
      "Content-Type": "application/json",
      token: userToken
    };
  
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
  
    this.otpVerifyApiCallId = requestMessage.messageId;
  
    // ✅ Add query params
    const endPoint = `${configJSON.getEndUSerOTPVerifyAPiEndPoint}?otp=${otp}&first_name=${encodeURIComponent(userName)}`;
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      endPoint
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );
  
    runEngine.sendMessage(requestMessage.id, requestMessage);
  
    return true;
  };
  
  submitReview = () => {
    console.log("enter post log");
    
    const { userToken, rating, description } = this.state;
  
    if (!rating) {
      alert("Please select rating");
      return;
    }
  
    if (!description) {
      alert("Please enter review description");
      return;
    }
  
    const header = {
      "Content-Type": "application/json",
      token: userToken
    };
  
    const requestBody = {
      account_id: this.getBusinessAccountId(),
      title: "User Review", // or make dynamic
      description: description,
      rating: rating
    };
  
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
  
    this.submitReviewApiCallId = requestMessage.messageId;
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getEndUSerPostReviewAPiEndPoint
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPostMethod
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(requestBody)
    );
  
    this.setState({ isSubmitting: true });
  
    runEngine.sendMessage(requestMessage.id, requestMessage);
  
    return true;
  };
  
  // Wizard Methods
  

  onChangePhone = (text: string) => {
    this.setState({ phoneNumber: text });
  };

  submitReviewWizard = () => {
    this.addQueryApi();
    this.nextStep(); // Move to success step
  };

  // Customizable Area End
}
